import { useState, useEffect, useCallback } from 'react';
import { Product } from '../types/pos.types';
import { posService } from '@/services/pos.service';

export const useProducts = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('1');
  const [showDeliveryOnly, setShowDeliveryOnly] = useState(false);

  const loadProducts = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await posService.getProducts({
        search: searchQuery || undefined,
        category: selectedCategory !== 'all' ? selectedCategory : undefined,
        isDelivery: showDeliveryOnly || undefined,
      });

      if (response.success) {
        setProducts(response.data);
      } else {
        throw new Error('Error al cargar productos');
      }
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Error desconocido');
      console.error('Error loading products:', error);
    } finally {
      setLoading(false);
    }
  }, [searchQuery, selectedCategory, showDeliveryOnly]);

  // Cargar productos inicialmente y cuando cambien los filtros
  useEffect(() => {
    loadProducts();
  }, [loadProducts]);

  return {
    products,
    loading,
    error,
    searchQuery,
    selectedCategory,
    showDeliveryOnly,
    setSearchQuery,
    setSelectedCategory,
    setShowDeliveryOnly,
    refetch: loadProducts
  };
};
